/**
 * Functions related to sticky elements functionality
 *
 */

import stickybits from 'stickybits';

export const stickyElements = function () {

	/**
	 * Make `.js-sticky-social` sticky on scroll
	 *
	 */
	stickybits('.js-sticky-social', {
		stickyBitStickyOffset: 120
	});

};
